export default "__VITE_ASSET__irE3LKnp__"